import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import CardHeader from "@mui/material/CardHeader";
import Grid from "@mui/material/Grid";
import React from "react";
import Typography from "@mui/material/Typography";
import { useGetSailInfoSalesPerson } from "../hooks/useGetSailInfoSalesPerson";

type SailInfoSalesPersonProps = {
    guid: string;
};

const SailInfoSalesPerson: React.FC<SailInfoSalesPersonProps> = ({ guid }) => {
    const { data, isLoading } = useGetSailInfoSalesPerson(guid);

    if (isLoading || !data) {
        return null;
    }

    return (
        <Card sx={{ width: "100%" }}>
            <CardHeader title="Sales Contact" />
            <CardContent>
                <Grid container spacing={2}>
                    <Grid size={6}>
                        <Typography variant="caption">Name</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">
                            {data.firstName} {data.lastName}
                        </Typography>
                    </Grid>

                    <Grid size={6}>
                        <Typography variant="caption">Email</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">{data.email}</Typography>
                    </Grid>

                    <Grid size={6}>
                        <Typography variant="caption">Phone</Typography>
                    </Grid>
                    <Grid size={6}>
                        <Typography variant="body1">{data.phone}</Typography>
                    </Grid>
                </Grid>
            </CardContent>
        </Card>
    );
};

export default SailInfoSalesPerson;
